import React from 'react';
import { Autocomplete, Checkbox, Chip, TextField } from '@mui/material';
import { useData, useFilter } from '../../providers';
import { useTranslation } from 'react-i18next';

export const OrderOriginsFilter = () => {
  const { saveFilter, filter } = useFilter();
  const { orderOrigins } = useData();
  const { t } = useTranslation('translation');

  return (
    <Autocomplete
      disablePortal
      multiple
      size="small"
      disableCloseOnSelect
      value={orderOrigins.reduce((acc, value) => {
        if ((filter.origins || []).includes(value.name)) {
          acc.push(value);
        }
        return acc;
      }, [])}
      options={orderOrigins}
      sx={{ minWidth: 300, height: 40 }}
      data-testid="order-origins"
      getOptionLabel={(option) => option.display_name}
      onChange={(_, values) => {
        if (values.length) {
          saveFilter({
            ...filter,
            origins: values.map((v) => v.name),
          });
        } else {
          saveFilter({
            ...filter,
            origins: null,
          });
        }
      }}
      renderOption={(props, option, { selected }) => (
        <li {...props}>
          <Checkbox
            style={{ marginRight: 8 }}
            checked={selected}
            size={'small'}
          />
          {option.display_name || option.name}
        </li>
      )}
      renderTags={(options, getTagProps) => (
        <>
          {options.slice(0, 2).map((option, index) => (
            <Chip
              label={option.display_name || option.name}
              size={'small'}
              {...getTagProps({ index })}
            />
          ))}
          {options.length > 2 && <span>+{options.length - 2}</span>}
        </>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={t('filters.origins')}
          margin={'dense'}
          size={'small'}
          sx={{ height: 40 }}
        />
      )}
      ListboxProps={{ 'data-testid': 'order-origins-list' }}
    />
  );
};
